// extracted by mini-css-extract-plugin
module.exports = {"headerForm":"Header_headerForm__1yPio","unAssignCol":"Header_unAssignCol__3CmRM"};